// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enterconference[data-v-6c850da4] {
  position: relative;
  color: var(--modal-text-color);
  font-size: 16px;
  height: auto;
  margin: 0 8px;
  flex: 1;
}
.enterconference .conf-item[data-v-6c850da4] {
  display: flex;
  align-items: center;
  height: 64px;
}
.enterconference .conf-item span[data-v-6c850da4] {
  width: 200px;
  line-height: 2.3;
}
@media screen and (max-width: 439px) {
.enterconference .conf-item span[data-v-6c850da4] {
    width: 128px;
}
}
.enterconference .conf-item .custom-select-wrapper[data-v-6c850da4] {
  width: 190px;
}
.enterconference .conf-item div.option[data-v-6c850da4] {
  height: 3em;
  width: 50%;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid var(--border-bottom-selecteditems);
}
.enterconference .conf-item div.option[data-v-6c850da4]:hover {
  background: var(--conf-tab-hover);
}
.enterconference .active[data-v-6c850da4] {
  background: var(--vm-btn-active);
}
.enterconference .conf-modes[data-v-6c850da4] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: auto;
}
.enterconference .conf-modes form[data-v-6c850da4] {
  margin-top: 10px;
}
.enterconference .custom-input-text[data-v-6c850da4] {
  width: 100%;
}
.enterconference .custom-input-text[data-v-6c850da4] .non-border-input {
  width: 100%;
}
.enterconference .subject .custom-input-text[data-v-6c850da4] {
  width: 100%;
}
.enterconference .custom-input-text-placeholder[data-v-6c850da4] {
  color: var(--modal-text-color) !important;
}
.enterconference .conf-auth[data-v-6c850da4],
.enterconference .linkway[data-v-6c850da4] {
  margin-top: 6px;
}
.enterconference .conf-settings a[data-v-6c850da4] {
  color: var(--modal-elem-color);
  cursor: pointer;
}
.enterconference .conf-settings a[data-v-6c850da4]:hover {
  color: var(--modal-elem-color);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/enterConferenceBody.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;AACA;IACI,YAAY;AAChB;AACA;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB","sourcesContent":[".enterconference[data-v-6c850da4] {\n  position: relative;\n  color: var(--modal-text-color);\n  font-size: 16px;\n  height: auto;\n  margin: 0 8px;\n  flex: 1;\n}\n.enterconference .conf-item[data-v-6c850da4] {\n  display: flex;\n  align-items: center;\n  height: 64px;\n}\n.enterconference .conf-item span[data-v-6c850da4] {\n  width: 200px;\n  line-height: 2.3;\n}\n@media screen and (max-width: 439px) {\n.enterconference .conf-item span[data-v-6c850da4] {\n    width: 128px;\n}\n}\n.enterconference .conf-item .custom-select-wrapper[data-v-6c850da4] {\n  width: 190px;\n}\n.enterconference .conf-item div.option[data-v-6c850da4] {\n  height: 3em;\n  width: 50%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n  border-bottom: 1px solid var(--border-bottom-selecteditems);\n}\n.enterconference .conf-item div.option[data-v-6c850da4]:hover {\n  background: var(--conf-tab-hover);\n}\n.enterconference .active[data-v-6c850da4] {\n  background: var(--vm-btn-active);\n}\n.enterconference .conf-modes[data-v-6c850da4] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  height: auto;\n}\n.enterconference .conf-modes form[data-v-6c850da4] {\n  margin-top: 10px;\n}\n.enterconference .custom-input-text[data-v-6c850da4] {\n  width: 100%;\n}\n.enterconference .custom-input-text[data-v-6c850da4] .non-border-input {\n  width: 100%;\n}\n.enterconference .subject .custom-input-text[data-v-6c850da4] {\n  width: 100%;\n}\n.enterconference .custom-input-text-placeholder[data-v-6c850da4] {\n  color: var(--modal-text-color) !important;\n}\n.enterconference .conf-auth[data-v-6c850da4],\n.enterconference .linkway[data-v-6c850da4] {\n  margin-top: 6px;\n}\n.enterconference .conf-settings a[data-v-6c850da4] {\n  color: var(--modal-elem-color);\n  cursor: pointer;\n}\n.enterconference .conf-settings a[data-v-6c850da4]:hover {\n  color: var(--modal-elem-color);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
